import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import { StatusPill } from "@/components/hc/StatusPill";

const API = process.env.REACT_APP_BACKEND_URL;

const NAV = [
    { label: "Journey", to: "/" },
    { label: "Learning", to: "/learning" },
    { label: "Explainer studio", to: "/explainer" },
];

export const HCLayout = ({ children }) => {
    const { pathname } = useLocation();
    const [katlas, setKatlas] = useState(null);

    useEffect(() => {
        axios
            .get(`${API}/api/katlas/status`)
            .then((r) => setKatlas(r.data))
            .catch(() => setKatlas({ status: "unreachable" }));
    }, []);

    return (
        <div className="hc flex min-h-screen flex-col">
            <header className="border-b hairline bg-white/95 sticky top-0 z-30">
                <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 sm:px-8 lg:px-12">
                    <Link to="/" data-testid="hc-brand-link" className="no-underline">
                        <p className="mono-label">HealthCierge · KATLAS</p>
                        <p className="font-serif text-lg leading-tight" style={{ color: "var(--ink)" }}>
                            MLTC Models of Care
                        </p>
                    </Link>
                    <div className="flex items-center gap-6">
                        <nav className="hidden items-center gap-5 md:flex">
                            {NAV.map((n) => (
                                <Link
                                    key={n.to}
                                    to={n.to}
                                    data-testid={`hc-nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
                                    className="no-underline font-mono uppercase tracking-[0.12em]"
                                    style={{
                                        fontSize: 11,
                                        fontFamily: "JetBrains Mono, monospace",
                                        color: pathname === n.to ? "var(--forest)" : "var(--ink-muted)",
                                        borderBottom: pathname === n.to ? "1px solid var(--forest)" : "1px solid transparent",
                                        paddingBottom: 2,
                                    }}
                                >
                                    {n.label}
                                </Link>
                            ))}
                        </nav>
                        <StatusPill status={katlas?.status || "loading"} label={katlas?.label} />
                    </div>
                </div>
            </header>

            <main className="mx-auto w-full max-w-7xl flex-1 px-6 py-10 sm:px-8 lg:px-12">
                {children}
            </main>

            <footer className="border-t hairline bg-white">
                <div className="mx-auto max-w-7xl px-6 py-6 sm:px-8 lg:px-12">
                    <p className="mono-label" style={{ textTransform: "none", letterSpacing: "0.04em" }}>
                        This synthetic journey is a configurable model-of-care hypothesis for
                        clinical, public and operational review. It does not recommend treatment
                        or represent a validated care pathway. No real patients, clinical records,
                        referrals or service data. Receipts are simulated locally unless a KATLAS
                        credential is configured server-side. Not a clinical or regulatory system.
                    </p>
                </div>
            </footer>
        </div>
    );
};
